import { call, put, takeLatest } from 'redux-saga/effects';
import { actions } from './slice';
import { ISagaFunc } from 'services/actionConfigs';
import { IAuthData } from './types';
import storage from 'utils/sessionStorage';
import { IResponseData } from 'services/response';
import apis from './apis';
import navigate from 'utils/navigate';
import { actions as shopActions } from '../../shop/services/slice';

const getAllDevices: ISagaFunc<string> = function* ({ payload }) {
  try {
    const res: IResponseData<any> = yield call(apis.getAllDevices, payload);
    if (res.data.data) {
      yield put(actions.async.getAllDevices.success(res.data.data));
    }
  } catch (error) {
    yield put(actions.async.getAllDevices.fail({}));
  }
};

const saveAuthData: ISagaFunc<IAuthData> = function* ({ payload }) {
  yield put(shopActions.async.getAllProductByCategory.fetch());
  yield storage.token.set(payload.accessToken);
  yield storage.refreshToken.set(payload.refreshToken);
};

const expiredToken = function* () {
  yield storage.token.set('');
  yield storage.refreshToken.set('');
  navigate('/login');
};

export const refreshToken = function* () {
  const refreshToken = storage.refreshToken.get();
  if (refreshToken) {
    try {
      const res: IResponseData<any> = yield call(
        apis.refreshToken,
        refreshToken
      );

      if (res.data.data) {
        yield put(actions.saveAuthData(res.data.data));
        yield put(shopActions.async.getAllProductByCategory.fetch());
      }
    } catch (error) {
      yield put(actions.expiredToken());
    }
  }
};

export default function* sagas() {
  yield takeLatest(actions.saveAuthData, saveAuthData);
  yield takeLatest(actions.expiredToken, expiredToken);
  yield takeLatest(actions.async.getAllDevices.fetch, getAllDevices);
}
